import "./highlights.css";
import {
  FaBuilding,
  FaLayerGroup,
  FaShieldAlt,
  FaRulerCombined,
  FaHome,
  FaThLarge,
  FaKey,
  FaDoorOpen,
  FaSnowflake
} from "react-icons/fa";

export default function Highlights() {
  return (
    <section className="highlights" id="highlights">

      <div className="highlights-header">
        <p>Highlights</p>
        <h2>Life how you like it</h2>
      </div>

      <div className="timeline">

        <div className="timeline-item">
          <div className="dot"><FaBuilding /></div>
          <div className="content">
            <h3>Project Scale</h3>
            <p>6 towers with 12 floors each and 139 total units.</p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="dot"><FaLayerGroup /></div>
          <div className="content">
            <h3>Land Area</h3>
            <p>Spans over 3.36 acres of land with premium open spaces.</p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="dot"><FaShieldAlt /></div>
          <div className="content">
            <h3>Structure</h3>
            <p>Earthquake-resistant RCC framed structure.</p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="dot"><FaRulerCombined /></div>
          <div className="content">
            <h3>Ceiling Height</h3>
            <p>Floor-to-floor height is 3.15 meters for spacious living.</p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="dot"><FaHome /></div>
          <div className="content">
            <h3>Premium Interiors</h3>
            <p>Italian marble flooring in living & dining areas.</p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="dot"><FaThLarge /></div>
          <div className="content">
            <h3>Bathroom Finishes</h3>
            <p>Somany tiles or equivalent in toilets & balconies.</p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="dot"><FaKey /></div>
          <div className="content">
            <h3>Premium Fixtures</h3>
            <p>Grohe CP fittings with Toto sanitary ware.</p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="dot"><FaDoorOpen /></div>
          <div className="content">
            <h3>Windows & Doors</h3>
            <p>Tostem sliding windows with 6mm glass panels.</p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="dot"><FaSnowflake /></div>
          <div className="content">
            <h3>Climate Comfort</h3>
            <p>Provision for VRV air conditioning system.</p>
          </div>
        </div>

      </div>
    </section>
  );
}